<template>
  <div class="modal fade in" ref="modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">{{title}} Domain</h4>
        </div>
        <div class="modal-body">
          <form class="form-horizontal">
            <div class="form-group">
              <label
                class="col-sm-3 control-label agent-edit-modal-name"
              >Short</label>
              <div class="col-sm-9 agent-edit-modal-name">
                <input
                  class="form-control"
                  placeholder="Short"
                  v-model="formData.short"
                  :disabled="isEdit"
                >
              </div>
            </div>
            <div class="form-group">
              <label
                class="col-sm-3 control-label agent-edit-modal-name"
              >Content Type</label>
              <div class="col-sm-9 agent-edit-modal-name">
                <input
                  class="form-control"
                  placeholder="Content Type"
                  v-model="formData.contenttype"
                >
              </div>
            </div>
            <div class="form-group">
              <label
                class="col-sm-3 control-label agent-edit-modal-name"
              >Content</label>
              <div class="col-sm-9 agent-edit-modal-name">
                <textarea
                  class="form-control"
                  placeholder="Content"
                  v-model="formData.content"
                ></textarea>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-default pull-left"
            data-toggle="dropdown"
            v-show="this.isEdit"
          >Delete Domain</button>
          <ul class="dropdown-menu pull-left alert-del">
            <li>
              <i
                class="icon fa fa-warning alert-del-warning"
              ></i>Confirm to delete ?
            </li>
            <li>
              <button class="btn btn-default">Cancel</button>
              <button
                class="btn btn-danger"
                v-on:click="handleDelete"
              >Delete</button>
            </li>
          </ul>
          <button
            type="button"
            class="btn btn-info"
            v-on:click="handleSave"
          >Save changes</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
</template>
<script>
import api from "../../api";

export default {
  name: "domain-form-modal",
  props: {
    type: String,
    fetch: Function
  },
  data() {
    return {
      title: this.$props.type === "edit" ? "Edit" : "Create",
      formData: {}
    };
  },
  computed: {
    isEdit() {
      return this.$props.type === "edit";
    }
  },
  methods: {
    async handleSave() {
      const path = this.$props.type === "edit" ? "update" : "create";
      await api.post({
        path: `/domain/${path}?_type=json`,
        data: { ...this.formData },
        withLoading: true
      });
      await this.$props.fetch();
      this.hide();
    },
    async handleDelete() {
      await api.post({
        path: `/domain/delete?_type=json`,
        data: { short: this.formData.short },
        withLoading: true
      });
      await this.$props.fetch();
      this.hide();
    },
    show(data) {
      this.formData = { ...data };
      window.jQuery(this.$refs.modal).modal("show");
    },
    hide() {
      window.jQuery(this.$refs.modal).modal("hide");
    }
  }
};
</script>



// WEBPACK FOOTER //
// DomainFormModal.vue?420e7489